"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replacePlaceholders = void 0;
const replacePlaceholders = (input, placeholders, options = {}) => {
    const { strict, defaultPlaceholder } = Object.assign({ strict: false }, options);
    if (input === null || input === undefined)
        return input;
    if (typeof placeholders != "object")
        return;
    else if (Array.isArray(input))
        return input.map((value) => (0, exports.replacePlaceholders)(value, placeholders, options));
    else if (typeof input == "object" && input !== null)
        return Object.entries(input).reduce((a, [key, value]) => {
            a[key] = (0, exports.replacePlaceholders)(value, placeholders, options);
            return a;
        }, {});
    const pattern = /{{(.*?)}}/g;
    let match;
    let output = input;
    while ((match = pattern.exec(input))) {
        const [current, key] = match;
        if (!strict && current == match.input && !Reflect.has(placeholders, key) && defaultPlaceholder === undefined)
            return;
        if (strict && placeholders[key] === undefined && defaultPlaceholder === undefined)
            throw new Error(`placeholder '${key}' is undefined`);
        output = output.replace(current, placeholders[key] ?? defaultPlaceholder ?? current);
    }
    return output;
};
exports.replacePlaceholders = replacePlaceholders;
